export default {
  manual: 'Manual',
  filters: {
    status: 'Estado',
    event_type: 'Tipo de evento',
  },
  columns: {
    event: 'Evento',
    status: 'Estado',
    attempts: 'Tentativas',
    last_http_status: 'Último estado HTTP',
    created_at: 'Criado em',
  },
  statuses: {
    pending: 'Pendente',
    delivered: 'Entregue',
    failed: 'Falhou',
  },
  buttons: {
    details: 'Detalhes',
    resend: 'Reenviar',
  },
  detail: {
    title: 'Detalhes da entrega',
    event: 'Evento',
    attempts: 'Tentativas',
    no_attempts: 'Ainda sem tentativas.',
    no_response: 'sem resposta',
    payload: 'Payload',
  },
  toasts: {
    load_error: 'Não foi possível carregar as entregas.',
    resend_error: 'Não foi possível reenviar a entrega.',
    resent: 'Entrega colocada na fila para reenvio.',
  },
};
